import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

export interface EquipoDTO {
  id: string;
  codigo: string | null;
  nombre: string;
  descripcion: string | null;
  stock_total: number;
  stock_disponible: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export function useEquipos() {
  return useQuery({
    queryKey: queryKeys.equipos.all,
    queryFn: async () => {
      const res = await api.get<{ data: EquipoDTO[] }>('/equipos');
      return res.data.data;
    },
  });
}

export function useCreateEquipo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { nombre: string; descripcion?: string | null; stockTotal: number }) => {
      const res = await api.post<{ data: EquipoDTO }>('/equipos', data);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.equipos.all });
    },
  });
}

export function useUpdateEquipo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { equipoId: string; data: { nombre?: string; descripcion?: string | null } }) => {
      const res = await api.put<{ data: EquipoDTO }>(`/equipos/${vars.equipoId}`, vars.data);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.equipos.all });
    },
  });
}

export function useDeleteEquipo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await api.delete(`/equipos/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.equipos.all });
    },
  });
}
